import React from 'react'
import { Container } from 'react-bootstrap'
import Meta from '../components/Meta'

const PrivacyPolicyScreen = () => {
  return (
    <Container>
      <Meta title='Privacy Policy — lotustor.com' robots='index,follow' />
      <h1>Privacy Policy</h1>
      <p>Last updated: October 25, 2025</p>
      <p>
        This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. By accessing or using our services, you agree to this Privacy Policy.
      </p>
      <h3>Information We Collect</h3>
      <ul>
        <li>Account information (name, email, username)</li>
        <li>Order and shipping details</li>
        <li>Payment status and transaction identifiers (processed by payment providers)</li>
        <li>Technical data such as IP address, device, and cookies</li>
      </ul>
      <h3>How We Use Information</h3>
      <ul>
        <li>To process and fulfill orders</li>
        <li>To provide and improve our services</li>
        <li>To communicate order updates and support</li>
        <li>To comply with legal obligations</li>
      </ul>
      <h3>Sharing of Information</h3>
      <p>
        We share information with service providers who help us operate our services (e.g., payment processing, shipping, email delivery). We do not sell your personal information.
      </p>
      <h3>Data Retention</h3>
      <p>We retain information as long as needed for the purposes described and as required by law.</p>
      <h3>Your Rights</h3>
      <p>You may request access, correction, or deletion of your personal information, subject to legal exceptions.</p>
      <h3>Contact Us</h3>
      <p>If you have questions, contact support via the Contact page.</p>
    </Container>
  )
}

export default PrivacyPolicyScreen
